type Translation = {
  en: string;
  "pt-BR": string;
}

type TechDescriptions = {
  [key: string]: Translation;
}

export const allTechs: TechDescriptions = {
  React: {
    en: "A JavaScript library for building user interfaces, developed by Facebook",
    "pt-BR": "Uma biblioteca JavaScript para construir interfaces de usuário, desenvolvida pelo Facebook"
  },
  Vite: {
    en: "A modern frontend build tool that offers a faster and leaner development experience",
    "pt-BR": "Uma ferramenta moderna de build frontend que oferece uma experiência de desenvolvimento mais rápida e eficiente"
  },
  TypeScript: {
    en: "A strongly typed programming language that builds on JavaScript",
    "pt-BR": "Uma linguagem de programação fortemente tipada que se baseia em JavaScript"
  },
  "Tailwind CSS": {
    en: "A utility-first CSS framework for rapidly building custom user interfaces",
    "pt-BR": "Um framework CSS utility-first para construir interfaces de usuário personalizadas rapidamente"
  },
  "Shadcn/ui": {
    en: "A collection of reusable components built using Radix UI and Tailwind CSS",
    "pt-BR": "Uma coleção de componentes reutilizáveis construídos usando Radix UI e Tailwind CSS"
  },
  Kotlin: {
    en: "A versatile programming language that supports multiplatform development, including Android, web, server-side, and native applications",
    "pt-BR": "Uma linguagem de programação versátil que suporta desenvolvimento multiplataforma, incluindo Android, web, servidor e aplicações nativas"
  },
  "Jetpack Compose": {
    en: "Android's modern declarative UI toolkit that simplifies and accelerates UI development. It enables building native UIs through composable functions, offering better code organization, real-time previews, and seamless state management. Benefits include reduced boilerplate code, improved maintainability, and built-in material design support.",
    "pt-BR": "Kit de ferramentas declarativo moderno do Android que simplifica e acelera o desenvolvimento de UI. Permite construir interfaces nativas através de funções componíveis, oferecendo melhor organização de código, previews em tempo real e gerenciamento de estado simplificado. Os benefícios incluem redução de código boilerplate, melhor manutenibilidade e suporte nativo ao material design."
  },
  "Node.js": {
    en: "JavaScript runtime built on Chrome's V8 JavaScript engine",
    "pt-BR": "Runtime JavaScript construído sobre o motor V8 do Chrome"
  },
  MongoDB: {
    en: "NoSQL database program that uses JSON-like documents",
    "pt-BR": "Programa de banco de dados NoSQL que usa documentos semelhantes a JSON"
  },
  Express: {
    en: "Fast, unopinionated, minimalist web framework for Node.js",
    "pt-BR": "Framework web rápido, minimalista e flexível para Node.js"
  },
  "Socket.io": {
    en: "Library that enables real-time, bidirectional and event-based communication",
    "pt-BR": "Biblioteca que permite comunicação em tempo real, bidirecional e baseada em eventos"
  },
  SSML: {
    en: "Speech Synthesis Markup Language for generating synthetic speech",
    "pt-BR": "Linguagem de Marcação de Síntese de Fala para gerar fala sintética"
  },
  TTS: {
    en: "Text-to-Speech technology for converting text into spoken voice output",
    "pt-BR": "Tecnologia de conversão de texto em voz para converter texto em saída de voz falada"
  },
  IVR: {
    en: "Interactive Voice Response system for automated phone interactions",
    "pt-BR": "Sistema de Resposta Interativa de Voz para interações telefônicas automatizadas"
  },
  MERN: {
    en: "Full-stack JavaScript framework combining MongoDB, Express, React, and Node.js",
    "pt-BR": "Framework JavaScript full-stack combinando MongoDB, Express, React e Node.js"
  },
  "Javascript": {
    en: "High-level, interpreted programming language that conforms to ECMAScript specification",
    "pt-BR": "Linguagem de programação interpretada de alto nível que segue a especificação ECMAScript"
  },
  Sass: {
    en: "CSS extension language adding power and elegance to basic CSS",
    "pt-BR": "Linguagem de extensão CSS que adiciona poder e elegância ao CSS básico"
  },
  "View XML": {
    en: "Android's traditional UI toolkit for defining user interface layouts",
    "pt-BR": "Kit de ferramentas tradicional do Android para definir layouts de interface do usuário"
  },
  "Brothers API": {
    en: "API for Brother printers integration and management",
    "pt-BR": "API para integração e gerenciamento de impressoras Brother"
  },
  IoT: {
    en: "Internet of Things - network of physical objects embedded with sensors and software",
    "pt-BR": "Internet das Coisas - rede de objetos físicos incorporados com sensores e software"
  },
  "Android SDK": {
    en: "Software Development Kit for creating Android applications, providing essential tools and APIs",
    "pt-BR": "Kit de Desenvolvimento de Software para criar aplicações Android, fornecendo ferramentas e APIs essenciais"
  },
  "MVVM": {
    en: "Model-View-ViewModel architectural pattern where: Model manages data and business logic; View handles UI elements and user interaction; ViewModel acts as a mediator between Model and View, converting data for display and managing UI logic. This separation enables better testing, maintenance, and code reuse while promoting a clean, decoupled architecture.",
    "pt-BR": "Padrão arquitetural Model-View-ViewModel onde: Model gerencia dados e lógica de negócios; View lida com elementos UI e interação do usuário; ViewModel atua como mediador entre Model e View, convertendo dados para exibição e gerenciando lógica UI. Esta separação permite melhor testabilidade, manutenção e reuso de código, promovendo uma arquitetura limpa e desacoplada."
  },
  "FCM": {
    en: "Firebase Cloud Messaging for sending notifications and messages across platforms",
    "pt-BR": "Firebase Cloud Messaging para enviar notificações e mensagens entre plataformas"
  },
  "MVC": {
    en: "Model-View-Controller architectural pattern that separates an application into three main components: Model (manages data, business logic, and rules), View (handles data presentation and user interface), and Controller (processes user input, manipulates the Model, and updates the View). This separation promotes organized code structure, easier maintenance, and the ability to modify components independently. Benefits include code reusability, parallel development, and high cohesion with loose coupling.",
    "pt-BR": "Padrão arquitetural Model-View-Controller que separa uma aplicação em três componentes principais: Model (gerencia dados, lógica de negócios e regras), View (lida com apresentação de dados e interface do usuário), e Controller (processa entrada do usuário, manipula o Model e atualiza a View). Esta separação promove estrutura organizada de código, manutenção mais fácil e capacidade de modificar componentes independentemente. Benefícios incluem reusabilidade de código, desenvolvimento paralelo e alta coesão com baixo acoplamento."
  },
  "Volley": {
    en: "HTTP library for Android that makes networking easier and faster",
    "pt-BR": "Biblioteca HTTP para Android que torna o networking mais fácil e rápido"
  },
  "OCR": {
    en: "Optical Character Recognition technology for converting images of text into machine-encoded text",
    "pt-BR": "Tecnologia de Reconhecimento Óptico de Caracteres para converter imagens de texto em texto codificado por máquina"
  },
  "Retrofit": {
    en: "Type-safe HTTP client for Android and Java that simplifies API communication",
    "pt-BR": "Cliente HTTP type-safe para Android e Java que simplifica a comunicação com APIs"
  },
  "Java": {
    en: "Object-oriented programming language designed for platform independence",
    "pt-BR": "Linguagem de programação orientada a objetos projetada para independência de plataforma"
  },
  "ZXing": {
    en: "Open-source, multi-format 1D/2D barcode image processing library",
    "pt-BR": "Biblioteca de código aberto para processamento de imagens de código de barras 1D/2D em múltiplos formatos"
  },
  "AWS cloud": {
    en: "Amazon Web Services - comprehensive cloud computing platform offering various services for building scalable applications",
    "pt-BR": "Amazon Web Services - plataforma abrangente de computação em nuvem oferecendo vários serviços para construir aplicações escaláveis"
  },
  "RoomDB": {
    en: "Android's recommended SQLite object mapping library providing an abstraction layer over SQLite",
    "pt-BR": "Biblioteca de mapeamento de objetos SQLite recomendada para Android fornecendo uma camada de abstração sobre SQLite"
  },
  "Google Maps": {
    en: "Platform offering detailed mapping services, location data, and navigation capabilities",
    "pt-BR": "Plataforma que oferece serviços detalhados de mapeamento, dados de localização e recursos de navegação"
  },
  "Generative AI": {
    en: "Artificial Intelligence systems capable of creating new content, including text, images, code, and more, by learning patterns from existing data",
    "pt-BR": "Sistemas de Inteligência Artificial capazes de criar novo conteúdo, incluindo texto, imagens, código e mais, através do aprendizado de padrões em dados existentes"
  },
  "SQL": {
    en: "Structured Query Language - standard language for managing and manipulating relational databases",
    "pt-BR": "Linguagem de Consulta Estruturada - linguagem padrão para gerenciar e manipular bancos de dados relacionais"
  },
  "Admob": {
    en: "Google's mobile advertising platform for monetizing applications with various ad formats",
    "pt-BR": "Plataforma de publicidade móvel do Google para monetização de aplicativos com vários formatos de anúncios"
  },
  "Google Billing": {
    en: "Google Play's in-app billing service that enables selling digital content and subscriptions within Android applications",
    "pt-BR": "Serviço de faturamento in-app do Google Play que permite a venda de conteúdo digital e assinaturas dentro de aplicativos Android"
  }
}; 